import TitleHeader from "../../general/TitleHeader";
import { FaLaptopCode } from "react-icons/fa";
import { PROJECTS } from "../../store/projectsData/projectsData";
import { Link } from "react-router-dom";
import { Zoom } from "react-awesome-reveal";
import CardProject from "../../components/CardProject";

export default function Projects() {
  return (
    <section id="projects" className="bg-dark-slate">
      <TitleHeader icon={<FaLaptopCode />} title={"My Projects"} />
      <div className="container grid grid-cols-auto gap-10">
        {/* *********************************************************************************************************** */}
        {/* animation */}
        <Zoom>
          {PROJECTS.slice(0, 3).map((obj) => (
            // card project
            <CardProject key={obj.id} obj={obj} />
          ))}
        </Zoom>
        {/* *********************************************************************************************************** */}
      </div>

      {/* link react-router-dom to  */}
      <Link
        to={`/projects`}
        // block w-fit bg-[#2506ad] text-white py-2 px-4 rounded-lg mx-auto mt-20
        className="mx-auto mt-20 sp-button-components"
      >
        All Projects
      </Link>
    </section>
  );
}
